import { render } from "./PolyclinicComponent.vue?vue&type=template&id=45d4ece8"
import script from "./PolyclinicComponent.vue?vue&type=script&lang=js"
export * from "./PolyclinicComponent.vue?vue&type=script&lang=js"

import exportComponent from "/builds/kinarya-jqdev/jqdev/admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__